import React from 'react';
import { useParams } from 'react-router-dom';

const TestPage = () => {
  const params = useParams();
  
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0a0a1a', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <h1>测试页面</h1>
        <p>Course ID: {params.courseId}</p>
        <p>Lesson ID: {params.lessonId}</p>
        <p>路由参数正常工作！</p>
      </div>
    </div>
  );
};

export default TestPage;